import React from "react";
import { Col, Row } from "react-bootstrap";
import StatCard from "../Common/StatCard";
import RecentActivity from "./RecentActivity";
import Alerts from "../Overview/Alerts";
import ChemicalLevel from "./ChemicalLevel";
import HourlyTrafficChart from "./HourlyTrafficChart";
import QueueWaitChart from "./QueueWaitChart";
import StatCardGroup from "../Common/StatCardGroup";

const Operations = () => {
  const DASHBOARD_STATS = [
    {
      id: "systemUpTime",
      title: "System Uptime",
      value: "10%",
      icon: "systemUpTime",
    },
    {
      id: "ANPRSuccessRate",
      title: "ANPR Success Rate",
      value: "30%",
      icon: "ANPRSuccessRate",
    },
    {
      id: "manualIntervention",
      title: "Manual Intervention",
      value: 12,
      icon: "manualIntervention",
    },
    {
      id: "emergencyExitActivated",
      title: "Emergency Exit Activated",
      value: 24,
      icon: "emergencyExitActivated",
    },
    {
      id: "carsExteriorTunnel",
      title: "Cars in exterior tunnel",
      value: 25,
      icon: "carsExteriorTunnel",
    },
    {
      id: "carsInteriorTunnel",
      title: "Cars in interior tunnel",
      value: "5",
      icon: "carsInteriorTunnel",
    },
    {
      id: "avgWashTime",
      title: "Avg.Interior Wash Time",
      value: "15 min",
      icon: "avgWashTime",
    },
    {
      id: "abortedWashes",
      title: "Failed / Aborted Washes",
      value: "09",
      icon: "abortedWashes",
    },
  ];
  return (
    <div className="operation_dashboard">
      <StatCardGroup items={DASHBOARD_STATS} />
      <Row>
        <Col lg={7}>
          <HourlyTrafficChart />
        </Col>
        <Col lg={5}>
          <QueueWaitChart />
        </Col>
      </Row>
      <Row>
        <Col lg={7}>
          <ChemicalLevel />
        </Col>
        <Col lg={5}>
          <Alerts />
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <RecentActivity />
        </Col>
      </Row>
    </div>
  );
};

export default Operations;
